module.exports = __webpack_public_path__ + "media/images/check-2-1a7d4b591416db37d02d8ca6e9260861.png";